import Section from '@/components/surface/Section';
import {defaultQueryOptions} from 'pages/_utils';
import {useShow} from '@refinedev/core';
import Spinner from '@/components/basic/Spinner';
import {useSetCustomBreadcrumb} from '@/hooks/useBreadcrumbs';
import useMyResourceParams from '@/hooks/refinedev/useMyResourceParams';
import {Avatar} from '@/shadcn_components/ui/avatar';

export const UserShow = () => {
  const resParams = useMyResourceParams();
  // const [searchParams] = useSearchParams();
  // const defaultTab = searchParams.get('tab') || 'general_info'; // Lấy tab từ URL

  // const handleTabChange = (tab: string) => {
  //   const currentUrl = new URL(window.location.href);
  //   currentUrl.searchParams.set('tab', tab);
  //   window.history.replaceState({}, '', currentUrl.toString()); // Cập nhật URL mà không reload
  // };

  const {query} = useShow({
    queryOptions: {
      ...defaultQueryOptions,
    },
    errorNotification: false,
    meta: {},
  });

  const {data, isFetching, error, isError} = query;
  const user = data?.data;

  useSetCustomBreadcrumb(user?.name);

  if (!resParams.id) return <p>Đường dẫn không hợp lệ</p>;

  if (isFetching) {
    return <Spinner />;
  }

  if (isError) {
    return <p>{error?.data?.message || 'Đã có lỗi xảy ra'}</p>;
  }

  if (!user) {
    return <p>Không tìm thấy thông tin</p>;
  }

  return (
    <div className="w-full flex flex-row flex-wrap gap-y-4">
      <div className="lg:basis-1/3 md:basis-1/2 w-full px-2">
        <Section title="Nhân viên" subtitle="Thông tin của nhân viên">
          <div className="space-y-4">
            {user.staff?.avatar && (
              <div className="flex flex-col gap-2">
                <span className="font-medium">Ảnh đại diện:</span>
                <Avatar className="w-32 h-32">
                  <img
                    src={user.staff.avatar}
                    alt="Avatar"
                    className="w-full h-full object-cover"
                  />
                </Avatar>
              </div>
            )}
            <div className="flex flex-col gap-2">
              <span className="font-medium">Số hiệu nhân viên:</span>
              <span>{user.staff?.staff_no}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Họ và tên:</span>
              <span>{user.staff?.name}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Số điện thoại:</span>
              <span>{user.staff?.mobile}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Email:</span>
              <span>{user.staff?.email}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Địa chỉ:</span>
              <span>{user.staff?.current_address}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Phòng ban:</span>
              <span>{user.staff?.department?.name}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Công việc:</span>
              <span>{user.staff?.job?.title}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Ghi chú:</span>
              <span>{user.staff?.notes}</span>
            </div>
          </div>
        </Section>
      </div>
      <div className="lg:basis-1/3 md:basis-1/2 w-full px-2">
        <Section title="Tài khoản" subtitle="Thông tin tài khoản">
          <div className="space-y-4">
            <div className="flex flex-col gap-2">
              <span className="font-medium">Tên đăng nhập:</span>
              <span>{user.username}</span>
            </div>
            <div className="flex flex-col gap-2">
              <span className="font-medium">Phân quyền:</span>
              <div className="flex flex-wrap gap-2">
                {user.roles?.map(role => (
                  <span key={role.id} className="px-2 py-1 bg-gray-100 rounded">
                    {role.name}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Section>
      </div>
    </div>
  );
};
